export const VALIDATION_DASHBOARD = 'VALIDATION_DASHBOARD'; // is board
export const VALIDATION_COMPANY = 'VALIDATION_COMPANY'; // is company
export const VALIDATION_MATRIX = 'VALIDATION_MATRIX'; // is matrix
export const VALIDATION_CVC = 'VALIDATION_CVC';
export const VALIDATION_ALL_STORE = 'VALIDATION_ALL_STORE';
